export enum NavigationSectionColor {
  Light = 'light',
  Dark = 'dark',
}

export interface NavigationSectionModel {
  colorTheme: NavigationSectionColor;
}
